import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ROUTES } from 'src/utils/constants';

@Component({
  selector: 'app-auth-fullwidth-container',
  templateUrl: './auth-fullwidth-container.component.html',
  styleUrls: ['./auth-fullwidth-container.component.scss'],
})
export class AuthFullwidthContainerComponent implements OnInit {
  status: string = '';

  constructor(private router: Router) {
    router.events.subscribe((val: any) => {
      if (val instanceof NavigationEnd) {
        this.status = this.router.url
          .replace(`${ROUTES.AUTH.AUTH}/`, '')
          .split('?')[0];
      }
    });
  }

  ngOnInit(): void {
    this.status = this.router.url
      .replace(`${ROUTES.AUTH.AUTH}/`, '')
      .split('?')[0];
  }

  showSuccessWindow(status: string) {
    this.status = status;
  }
}
